import { makeStyles } from 'tss-react/mui';
import { theme } from '../../../theme';

/**
 * Custom hook that defines the styles for the leaderboard component.
 */
const useLeaderboardStyles = makeStyles()(() => ({
  leaderboardContainerRow: {
    display: 'flex',
    flex: '1 0 0',
    borderRadius: theme.borderRadius.m,
    boxShadow: theme.containerShadow,
    overflow: 'hidden',
    fontFamily: theme.fontFamily,
    backgroundColor: theme.background.paper,
  },
  leaderboardContainerColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'space-between',
    fontFamily: theme.fontFamily,
  },
  userTableCell: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: theme.fontFamily,
  },
  userTableCellUsername: {
    marginLeft: '10px',
    fontFamily: theme.fontFamily,
  },
  titleAndBoardContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    fontFamily: theme.fontFamily,
  },
  tableRow: {
    '&:nth-of-type(even)': {
      backgroundColor: theme.background.lighter,
    },
    '&:hover': {
      backgroundColor: theme.background.light,
      cursor: 'pointer',
    },
  },
  headerTableCell: {
    backgroundColor: theme.background.lighter,
    fontFamily: theme.fontFamily,
  },
  toggleButton: {
    'display': 'flex',
    'flex': '1',
    'fontFamily': theme.fontFamily,
    'backgroundColor': theme.background.paper,
    'borderRadius': '0px 0px 15px 15px',
    'color': theme.text.primary.light,
    '&.Mui-selected': {
      'color': theme.text.primary.dark,
      'backgroundColor': theme.primary.light,
      '&:hover': {
        color: theme.text.primary.dark,
        backgroundColor: theme.primary.dark,
      },
      '&:active': {
        backgroundColor: theme.primary.darker,
        boxShadow: theme.buttonShadow(theme.primary.darker),
        color: theme.text.primary.dark,
      },
    },
  },
  gameParrotIcon: {
    height: '55px',
    width: 'auto',
    cursor: 'pointer',
  },
  gameParrotCell: {
    paddingRight: '30px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '30px',
    height: '55px',
  },
}));

export default useLeaderboardStyles;
